/* tslint:disable */
/* eslint-disable */
/**
 * Bushfire Platform API
 * ![Bushfire.io](https://bushfire.io/images/logo/logo_96x96.png)  Programmatic access to the Bushfire Platform: live incidents, hotspots, lightning, weather, and analysis.  Your licence determines which data and endpoints you can access. Personal accounts cover private individual use, while commercial, government, education, and organisational use, including raw data access, is available under agreement.  Interested in raw data or an enterprise licence? We\'d love to hear from you at [hello@disasterscience.co](mailto:hello@disasterscience.co).  [Bushfire.io](https://bushfire.io) · [Disaster Science](https://disasterscience.co) · [Terms of Service](https://docs.disasterscience.co/terms)
 *
 * The version of the OpenAPI document: 1.8.36
 * Contact: hello@disasterscience.co
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { BfCreateKeyRequest } from '../models';
// @ts-ignore
import type { BfCreateUserRequest } from '../models';
// @ts-ignore
import type { BfCreatedKey } from '../models';
// @ts-ignore
import type { BfCredential } from '../models';
// @ts-ignore
import type { BfFeedback } from '../models';
// @ts-ignore
import type { BfKeyScopeAvailability } from '../models';
// @ts-ignore
import type { BfPlan } from '../models';
// @ts-ignore
import type { BfPlanAndroidIapValidate } from '../models';
// @ts-ignore
import type { BfPlanAppleIapResponse } from '../models';
// @ts-ignore
import type { BfPlanAppleIapValidate } from '../models';
// @ts-ignore
import type { BfStripeCheckoutSession } from '../models';
// @ts-ignore
import type { BfStripeCustomerPortal } from '../models';
// @ts-ignore
import type { BfUpdateUser } from '../models';
// @ts-ignore
import type { BfUser } from '../models';
// @ts-ignore
import type { RcApiSubscription } from '../models';
/**
 * UserApi - axios parameter creator
 */
export const UserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Mints a key for integrations: GIS clients (XYZ, WMTS, WMS, WFS), the Data API, event lookups, notifications, webhooks, custom layers and event management. The key is returned once and cannot be retrieved again. Each scope needs a group its `KeyScope*` policy component allows; `GET /v1/user/keys/scopes` lists the caller\'s.
         * @summary Create an access key
         * @param {BfCreateKeyRequest} bfCreateKeyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createKey: async (bfCreateKeyRequest: BfCreateKeyRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bfCreateKeyRequest' is not null or undefined
            assertParamExists('createKey', 'bfCreateKeyRequest', bfCreateKeyRequest)
            const localVarPath = `/v1/user/keys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bfCreateKeyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a Stripe subscription for the user
         * @summary Create Stripe subscription
         * @param {BfPlan} bfPlan 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStripeSubscription: async (bfPlan: BfPlan, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bfPlan' is not null or undefined
            assertParamExists('createStripeSubscription', 'bfPlan', bfPlan)
            const localVarPath = `/v1/user/billing/stripe`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bfPlan, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a new user account, with the given name and email address. If you specify a licence ID, the user will be assigned that licence. If you do not specify a licence ID, the first available licence for the organisation will be assigned ordered by licence type.  This endpoint is for enterprise users, and the user completing the registration must be a manager of that organisation and be an `Enterprise` licenced user. The new user must not already exist. If the user already exists, an error will be returned and the licencing API should be used directly to assign a licence to that user.
         * @summary Create new user
         * @param {BfCreateUserRequest} bfCreateUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser: async (bfCreateUserRequest: BfCreateUserRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bfCreateUserRequest' is not null or undefined
            assertParamExists('createUser', 'bfCreateUserRequest', bfCreateUserRequest)
            const localVarPath = `/v1/user/identity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bfCreateUserRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * User has requested to delete their account
         * @summary Delete user account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMyself: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/user/identity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Cancel\'s the Stripe subscription for the user, if there is one
         * @summary Cancel Stripe subscription
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStripeSubscription: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/user/billing/stripe`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Verifies the RevenueCat IAP transaction with RevenueCat
         * @summary Get revenuecat subscriptions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRevenuecatSubscriptions: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/user/billing/revenuecat`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sessions issued to the calling user, most recently seen first. A session appears once its app or browser has validated its token.
         * @summary List credentials
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCredentials: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/user/credentials`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Every access key scope, the groups (plans) that allow minting it, and whether the calling user\'s current groups do.
         * @summary List key scopes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listKeyScopes: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/user/keys/scopes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Revokes one of the calling user\'s access keys; its record stays listed as revoked. The API refuses it at once; map services stop accepting it within a day.
         * @summary Revoke an access key
         * @param {string} credentialId The key\&#39;s credential id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeKey: async (credentialId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'credentialId' is not null or undefined
            assertParamExists('revokeKey', 'credentialId', credentialId)
            const localVarPath = `/v1/user/keys/{credential_id}`
                .replace(`{${"credential_id"}}`, encodeURIComponent(String(credentialId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Signs one of the calling user\'s apps or browsers out: its tokens are refused by the API at once and by map services within a week. The session stays listed as revoked.
         * @summary Revoke a session
         * @param {string} credentialId The session\&#39;s credential id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeSession: async (credentialId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'credentialId' is not null or undefined
            assertParamExists('revokeSession', 'credentialId', credentialId)
            const localVarPath = `/v1/user/sessions/{credential_id}`
                .replace(`{${"credential_id"}}`, encodeURIComponent(String(credentialId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a portal session with Stripe which is sent back to the user to modify their subscription
         * @summary Update Stripe subscription
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStripeSubscriptionViaPortal: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/user/billing/stripe`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update user preferences as requested
         * @summary Update preferences
         * @param {BfUpdateUser} bfUpdateUser 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser: async (bfUpdateUser: BfUpdateUser, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bfUpdateUser' is not null or undefined
            assertParamExists('updateUser', 'bfUpdateUser', bfUpdateUser)
            const localVarPath = `/v1/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bfUpdateUser, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the user\'s name and email. An empty response indicates the email needs to be validated (and an email was sent).
         * @summary Update user identity
         * @param {BfUser} bfUser 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserIdentity: async (bfUser: BfUser, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bfUser' is not null or undefined
            assertParamExists('updateUserIdentity', 'bfUser', bfUser)
            const localVarPath = `/v1/user/identity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bfUser, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update user preferences as requested
         * @summary Update preferences
         * @param {BfUser} bfUser 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserPreferences: async (bfUser: BfUser, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bfUser' is not null or undefined
            assertParamExists('updateUserPreferences', 'bfUser', bfUser)
            const localVarPath = `/v1/user/preferences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bfUser, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Provide feedback about your user experience
         * @summary Provide feedback
         * @param {BfFeedback} bfFeedback 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userFeedback: async (bfFeedback: BfFeedback, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bfFeedback' is not null or undefined
            assertParamExists('userFeedback', 'bfFeedback', bfFeedback)
            const localVarPath = `/v1/user/feedback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bfFeedback, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the user\'s identity, after verifying they\'re logged in
         * @summary Get user identity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userIdentity: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/user/identity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Verifies the Android IAP transaction with Google
         * @summary Validate Google IAP subscription
         * @param {BfPlanAndroidIapValidate} bfPlanAndroidIapValidate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateAndroidIapSubscription: async (bfPlanAndroidIapValidate: BfPlanAndroidIapValidate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bfPlanAndroidIapValidate' is not null or undefined
            assertParamExists('validateAndroidIapSubscription', 'bfPlanAndroidIapValidate', bfPlanAndroidIapValidate)
            const localVarPath = `/v1/user/billing/android`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bfPlanAndroidIapValidate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Verifies the Apple IAP transaction with Apple
         * @summary Validate Apple IAP subscription
         * @param {BfPlanAppleIapValidate} bfPlanAppleIapValidate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateAppleIapSubscription: async (bfPlanAppleIapValidate: BfPlanAppleIapValidate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bfPlanAppleIapValidate' is not null or undefined
            assertParamExists('validateAppleIapSubscription', 'bfPlanAppleIapValidate', bfPlanAppleIapValidate)
            const localVarPath = `/v1/user/billing/apple`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bfPlanAppleIapValidate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Verifies the RevenueCat IAP transaction with RevenueCat
         * @summary Validate revenuecat subscription
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateRevenuecatSubscription: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/user/billing/revenuecat`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserApi - functional programming interface
 */
export const UserApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserApiAxiosParamCreator(configuration)
    return {
        /**
         * Mints a key for integrations: GIS clients (XYZ, WMTS, WMS, WFS), the Data API, event lookups, notifications, webhooks, custom layers and event management. The key is returned once and cannot be retrieved again. Each scope needs a group its `KeyScope*` policy component allows; `GET /v1/user/keys/scopes` lists the caller\'s.
         * @summary Create an access key
         * @param {BfCreateKeyRequest} bfCreateKeyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createKey(bfCreateKeyRequest: BfCreateKeyRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BfCreatedKey>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createKey(bfCreateKeyRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.createKey']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a Stripe subscription for the user
         * @summary Create Stripe subscription
         * @param {BfPlan} bfPlan 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createStripeSubscription(bfPlan: BfPlan, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BfStripeCheckoutSession>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createStripeSubscription(bfPlan, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.createStripeSubscription']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a new user account, with the given name and email address. If you specify a licence ID, the user will be assigned that licence. If you do not specify a licence ID, the first available licence for the organisation will be assigned ordered by licence type.  This endpoint is for enterprise users, and the user completing the registration must be a manager of that organisation and be an `Enterprise` licenced user. The new user must not already exist. If the user already exists, an error will be returned and the licencing API should be used directly to assign a licence to that user.
         * @summary Create new user
         * @param {BfCreateUserRequest} bfCreateUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createUser(bfCreateUserRequest: BfCreateUserRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BfUser>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createUser(bfCreateUserRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.createUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * User has requested to delete their account
         * @summary Delete user account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteMyself(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteMyself(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.deleteMyself']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Cancel\'s the Stripe subscription for the user, if there is one
         * @summary Cancel Stripe subscription
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteStripeSubscription(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteStripeSubscription(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.deleteStripeSubscription']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Verifies the RevenueCat IAP transaction with RevenueCat
         * @summary Get revenuecat subscriptions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRevenuecatSubscriptions(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RcApiSubscription>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRevenuecatSubscriptions(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.getRevenuecatSubscriptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sessions issued to the calling user, most recently seen first. A session appears once its app or browser has validated its token.
         * @summary List credentials
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCredentials(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BfCredential>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCredentials(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.listCredentials']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Every access key scope, the groups (plans) that allow minting it, and whether the calling user\'s current groups do.
         * @summary List key scopes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listKeyScopes(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BfKeyScopeAvailability>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listKeyScopes(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.listKeyScopes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Revokes one of the calling user\'s access keys; its record stays listed as revoked. The API refuses it at once; map services stop accepting it within a day.
         * @summary Revoke an access key
         * @param {string} credentialId The key\&#39;s credential id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revokeKey(credentialId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.revokeKey(credentialId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.revokeKey']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Signs one of the calling user\'s apps or browsers out: its tokens are refused by the API at once and by map services within a week. The session stays listed as revoked.
         * @summary Revoke a session
         * @param {string} credentialId The session\&#39;s credential id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revokeSession(credentialId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.revokeSession(credentialId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.revokeSession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a portal session with Stripe which is sent back to the user to modify their subscription
         * @summary Update Stripe subscription
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateStripeSubscriptionViaPortal(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BfStripeCustomerPortal>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateStripeSubscriptionViaPortal(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.updateStripeSubscriptionViaPortal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update user preferences as requested
         * @summary Update preferences
         * @param {BfUpdateUser} bfUpdateUser 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUser(bfUpdateUser: BfUpdateUser, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUser(bfUpdateUser, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.updateUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates the user\'s name and email. An empty response indicates the email needs to be validated (and an email was sent).
         * @summary Update user identity
         * @param {BfUser} bfUser 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserIdentity(bfUser: BfUser, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BfUser>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserIdentity(bfUser, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.updateUserIdentity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update user preferences as requested
         * @summary Update preferences
         * @param {BfUser} bfUser 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserPreferences(bfUser: BfUser, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserPreferences(bfUser, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.updateUserPreferences']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Provide feedback about your user experience
         * @summary Provide feedback
         * @param {BfFeedback} bfFeedback 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userFeedback(bfFeedback: BfFeedback, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userFeedback(bfFeedback, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.userFeedback']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the user\'s identity, after verifying they\'re logged in
         * @summary Get user identity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userIdentity(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BfUser>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userIdentity(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.userIdentity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Verifies the Android IAP transaction with Google
         * @summary Validate Google IAP subscription
         * @param {BfPlanAndroidIapValidate} bfPlanAndroidIapValidate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateAndroidIapSubscription(bfPlanAndroidIapValidate: BfPlanAndroidIapValidate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BfPlanAppleIapResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateAndroidIapSubscription(bfPlanAndroidIapValidate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.validateAndroidIapSubscription']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Verifies the Apple IAP transaction with Apple
         * @summary Validate Apple IAP subscription
         * @param {BfPlanAppleIapValidate} bfPlanAppleIapValidate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateAppleIapSubscription(bfPlanAppleIapValidate: BfPlanAppleIapValidate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BfPlanAppleIapResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateAppleIapSubscription(bfPlanAppleIapValidate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.validateAppleIapSubscription']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Verifies the RevenueCat IAP transaction with RevenueCat
         * @summary Validate revenuecat subscription
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateRevenuecatSubscription(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateRevenuecatSubscription(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.validateRevenuecatSubscription']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserApi - factory interface
 */
export const UserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserApiFp(configuration)
    return {
        /**
         * Mints a key for integrations: GIS clients (XYZ, WMTS, WMS, WFS), the Data API, event lookups, notifications, webhooks, custom layers and event management. The key is returned once and cannot be retrieved again. Each scope needs a group its `KeyScope*` policy component allows; `GET /v1/user/keys/scopes` lists the caller\'s.
         * @summary Create an access key
         * @param {BfCreateKeyRequest} bfCreateKeyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createKey(bfCreateKeyRequest: BfCreateKeyRequest, options?: RawAxiosRequestConfig): AxiosPromise<BfCreatedKey> {
            return localVarFp.createKey(bfCreateKeyRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a Stripe subscription for the user
         * @summary Create Stripe subscription
         * @param {BfPlan} bfPlan 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStripeSubscription(bfPlan: BfPlan, options?: RawAxiosRequestConfig): AxiosPromise<BfStripeCheckoutSession> {
            return localVarFp.createStripeSubscription(bfPlan, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a new user account, with the given name and email address. If you specify a licence ID, the user will be assigned that licence. If you do not specify a licence ID, the first available licence for the organisation will be assigned ordered by licence type.  This endpoint is for enterprise users, and the user completing the registration must be a manager of that organisation and be an `Enterprise` licenced user. The new user must not already exist. If the user already exists, an error will be returned and the licencing API should be used directly to assign a licence to that user.
         * @summary Create new user
         * @param {BfCreateUserRequest} bfCreateUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser(bfCreateUserRequest: BfCreateUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<BfUser> {
            return localVarFp.createUser(bfCreateUserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * User has requested to delete their account
         * @summary Delete user account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMyself(options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.deleteMyself(options).then((request) => request(axios, basePath));
        },
        /**
         * Cancel\'s the Stripe subscription for the user, if there is one
         * @summary Cancel Stripe subscription
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStripeSubscription(options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.deleteStripeSubscription(options).then((request) => request(axios, basePath));
        },
        /**
         * Verifies the RevenueCat IAP transaction with RevenueCat
         * @summary Get revenuecat subscriptions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRevenuecatSubscriptions(options?: RawAxiosRequestConfig): AxiosPromise<Array<RcApiSubscription>> {
            return localVarFp.getRevenuecatSubscriptions(options).then((request) => request(axios, basePath));
        },
        /**
         * Sessions issued to the calling user, most recently seen first. A session appears once its app or browser has validated its token.
         * @summary List credentials
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCredentials(options?: RawAxiosRequestConfig): AxiosPromise<Array<BfCredential>> {
            return localVarFp.listCredentials(options).then((request) => request(axios, basePath));
        },
        /**
         * Every access key scope, the groups (plans) that allow minting it, and whether the calling user\'s current groups do.
         * @summary List key scopes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listKeyScopes(options?: RawAxiosRequestConfig): AxiosPromise<Array<BfKeyScopeAvailability>> {
            return localVarFp.listKeyScopes(options).then((request) => request(axios, basePath));
        },
        /**
         * Revokes one of the calling user\'s access keys; its record stays listed as revoked. The API refuses it at once; map services stop accepting it within a day.
         * @summary Revoke an access key
         * @param {string} credentialId The key\&#39;s credential id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeKey(credentialId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.revokeKey(credentialId, options).then((request) => request(axios, basePath));
        },
        /**
         * Signs one of the calling user\'s apps or browsers out: its tokens are refused by the API at once and by map services within a week. The session stays listed as revoked.
         * @summary Revoke a session
         * @param {string} credentialId The session\&#39;s credential id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeSession(credentialId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.revokeSession(credentialId, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a portal session with Stripe which is sent back to the user to modify their subscription
         * @summary Update Stripe subscription
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStripeSubscriptionViaPortal(options?: RawAxiosRequestConfig): AxiosPromise<BfStripeCustomerPortal> {
            return localVarFp.updateStripeSubscriptionViaPortal(options).then((request) => request(axios, basePath));
        },
        /**
         * Update user preferences as requested
         * @summary Update preferences
         * @param {BfUpdateUser} bfUpdateUser 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser(bfUpdateUser: BfUpdateUser, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.updateUser(bfUpdateUser, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the user\'s name and email. An empty response indicates the email needs to be validated (and an email was sent).
         * @summary Update user identity
         * @param {BfUser} bfUser 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserIdentity(bfUser: BfUser, options?: RawAxiosRequestConfig): AxiosPromise<BfUser> {
            return localVarFp.updateUserIdentity(bfUser, options).then((request) => request(axios, basePath));
        },
        /**
         * Update user preferences as requested
         * @summary Update preferences
         * @param {BfUser} bfUser 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserPreferences(bfUser: BfUser, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.updateUserPreferences(bfUser, options).then((request) => request(axios, basePath));
        },
        /**
         * Provide feedback about your user experience
         * @summary Provide feedback
         * @param {BfFeedback} bfFeedback 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userFeedback(bfFeedback: BfFeedback, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.userFeedback(bfFeedback, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the user\'s identity, after verifying they\'re logged in
         * @summary Get user identity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userIdentity(options?: RawAxiosRequestConfig): AxiosPromise<BfUser> {
            return localVarFp.userIdentity(options).then((request) => request(axios, basePath));
        },
        /**
         * Verifies the Android IAP transaction with Google
         * @summary Validate Google IAP subscription
         * @param {BfPlanAndroidIapValidate} bfPlanAndroidIapValidate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateAndroidIapSubscription(bfPlanAndroidIapValidate: BfPlanAndroidIapValidate, options?: RawAxiosRequestConfig): AxiosPromise<BfPlanAppleIapResponse> {
            return localVarFp.validateAndroidIapSubscription(bfPlanAndroidIapValidate, options).then((request) => request(axios, basePath));
        },
        /**
         * Verifies the Apple IAP transaction with Apple
         * @summary Validate Apple IAP subscription
         * @param {BfPlanAppleIapValidate} bfPlanAppleIapValidate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateAppleIapSubscription(bfPlanAppleIapValidate: BfPlanAppleIapValidate, options?: RawAxiosRequestConfig): AxiosPromise<BfPlanAppleIapResponse> {
            return localVarFp.validateAppleIapSubscription(bfPlanAppleIapValidate, options).then((request) => request(axios, basePath));
        },
        /**
         * Verifies the RevenueCat IAP transaction with RevenueCat
         * @summary Validate revenuecat subscription
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateRevenuecatSubscription(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.validateRevenuecatSubscription(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserApi - object-oriented interface
 */
export class UserApi extends BaseAPI {
    /**
     * Mints a key for integrations: GIS clients (XYZ, WMTS, WMS, WFS), the Data API, event lookups, notifications, webhooks, custom layers and event management. The key is returned once and cannot be retrieved again. Each scope needs a group its `KeyScope*` policy component allows; `GET /v1/user/keys/scopes` lists the caller\'s.
     * @summary Create an access key
     * @param {BfCreateKeyRequest} bfCreateKeyRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createKey(bfCreateKeyRequest: BfCreateKeyRequest, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).createKey(bfCreateKeyRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a Stripe subscription for the user
     * @summary Create Stripe subscription
     * @param {BfPlan} bfPlan 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createStripeSubscription(bfPlan: BfPlan, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).createStripeSubscription(bfPlan, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a new user account, with the given name and email address. If you specify a licence ID, the user will be assigned that licence. If you do not specify a licence ID, the first available licence for the organisation will be assigned ordered by licence type.  This endpoint is for enterprise users, and the user completing the registration must be a manager of that organisation and be an `Enterprise` licenced user. The new user must not already exist. If the user already exists, an error will be returned and the licencing API should be used directly to assign a licence to that user.
     * @summary Create new user
     * @param {BfCreateUserRequest} bfCreateUserRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createUser(bfCreateUserRequest: BfCreateUserRequest, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).createUser(bfCreateUserRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * User has requested to delete their account
     * @summary Delete user account
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteMyself(options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).deleteMyself(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Cancel\'s the Stripe subscription for the user, if there is one
     * @summary Cancel Stripe subscription
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteStripeSubscription(options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).deleteStripeSubscription(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Verifies the RevenueCat IAP transaction with RevenueCat
     * @summary Get revenuecat subscriptions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getRevenuecatSubscriptions(options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).getRevenuecatSubscriptions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sessions issued to the calling user, most recently seen first. A session appears once its app or browser has validated its token.
     * @summary List credentials
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listCredentials(options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).listCredentials(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Every access key scope, the groups (plans) that allow minting it, and whether the calling user\'s current groups do.
     * @summary List key scopes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listKeyScopes(options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).listKeyScopes(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Revokes one of the calling user\'s access keys; its record stays listed as revoked. The API refuses it at once; map services stop accepting it within a day.
     * @summary Revoke an access key
     * @param {string} credentialId The key\&#39;s credential id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public revokeKey(credentialId: string, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).revokeKey(credentialId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Signs one of the calling user\'s apps or browsers out: its tokens are refused by the API at once and by map services within a week. The session stays listed as revoked.
     * @summary Revoke a session
     * @param {string} credentialId The session\&#39;s credential id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public revokeSession(credentialId: string, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).revokeSession(credentialId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a portal session with Stripe which is sent back to the user to modify their subscription
     * @summary Update Stripe subscription
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateStripeSubscriptionViaPortal(options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).updateStripeSubscriptionViaPortal(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update user preferences as requested
     * @summary Update preferences
     * @param {BfUpdateUser} bfUpdateUser 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateUser(bfUpdateUser: BfUpdateUser, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).updateUser(bfUpdateUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the user\'s name and email. An empty response indicates the email needs to be validated (and an email was sent).
     * @summary Update user identity
     * @param {BfUser} bfUser 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateUserIdentity(bfUser: BfUser, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).updateUserIdentity(bfUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update user preferences as requested
     * @summary Update preferences
     * @param {BfUser} bfUser 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateUserPreferences(bfUser: BfUser, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).updateUserPreferences(bfUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Provide feedback about your user experience
     * @summary Provide feedback
     * @param {BfFeedback} bfFeedback 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userFeedback(bfFeedback: BfFeedback, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).userFeedback(bfFeedback, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the user\'s identity, after verifying they\'re logged in
     * @summary Get user identity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userIdentity(options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).userIdentity(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Verifies the Android IAP transaction with Google
     * @summary Validate Google IAP subscription
     * @param {BfPlanAndroidIapValidate} bfPlanAndroidIapValidate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateAndroidIapSubscription(bfPlanAndroidIapValidate: BfPlanAndroidIapValidate, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).validateAndroidIapSubscription(bfPlanAndroidIapValidate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Verifies the Apple IAP transaction with Apple
     * @summary Validate Apple IAP subscription
     * @param {BfPlanAppleIapValidate} bfPlanAppleIapValidate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateAppleIapSubscription(bfPlanAppleIapValidate: BfPlanAppleIapValidate, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).validateAppleIapSubscription(bfPlanAppleIapValidate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Verifies the RevenueCat IAP transaction with RevenueCat
     * @summary Validate revenuecat subscription
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public validateRevenuecatSubscription(options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).validateRevenuecatSubscription(options).then((request) => request(this.axios, this.basePath));
    }
}

